import type { ExtractableBlockData } from '@octopus-do/octopus-project-core'

import { DEFAULT_PAGE_NAME } from '@/constants/defaultNames'
import type { NodesWithBlocks } from '@/types'
import { getBlockContent } from '@/utils'

const normalizeBlocks = (blocks: ExtractableBlockData[]) => {
  return blocks.map((block) => {
    return {
      title: block.title || 'Untitled',
      content: getBlockContent(block.content),
    }
  })
}

export const normalizeData = (nodes: NodesWithBlocks[]) => {
  return nodes.map((node) => {
    const blocks = normalizeBlocks(node.blocks)

    return {
      title: node.title || DEFAULT_PAGE_NAME,
      blocks,
    }
  })
}
